import React, { useEffect, useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import axios from "axios";
import Select from "react-select";

const emptyFilters = {
  id_user: "",
  assignFromDate: "",
  assignToDate: "",
  vehicle: "",
  approved: "",
  approvedBy: "",
  company: "",
};

export default function FilterModal({
  show,
  onHide,
  filters,
  onApplyFilters,
  onClearFilters,
}) {
  const [tempFilters, setTempFilters] = useState(emptyFilters);
  const [options, setOptions] = useState({
    users: [],
    vehicles: [],
    approvedByUsers: [],
    companies: [],
  });

  useEffect(() => {
    if (show) {
      setTempFilters({ ...emptyFilters, ...filters });
    }
  }, [show, filters]);

  useEffect(() => {
    if (!show) return;

    const fetchOptions = async () => {
      try {
        const token = localStorage.getItem("token");

        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/api/v1/assets/filter-options`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        );

        if (response.data?.success) {
          setOptions({
            users: response.data.users || [],
            vehicles: response.data.vehicles || [],
            approvedByUsers: response.data.approvedByUsers || [],
            companies: response.data.companies || [],
          });
        }
      } catch (error) {
        console.error(
          "Error loading asset filters:",
          error.response?.data || error,
        );
      }
    };

    fetchOptions();
  }, [show]);

  const updateFilter = (key, value) => {
    setTempFilters((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  const makeOptions = (items, getLabel) =>
    items
      .filter((item) => item?._id || typeof item === "string")
      .map((item) =>
        typeof item === "string"
          ? { value: item, label: item }
          : { value: item._id, label: getLabel(item) },
      );

  const userOptions = makeOptions(
    options.users,
    (item) => item.name || item.email || item._id,
  );

  const approvedByOptions = makeOptions(
    options.approvedByUsers,
    (item) => item.name || item.email || item._id,
  );

  const vehicleOptions = makeOptions(
    options.vehicles,
    (item) => item.numberplate || item.vehicleName || item._id,
  );

  const companyOptions = makeOptions(options.companies, (item) => item);

  const renderSelect = (label, key, selectOptions) => (
    <Form.Group className="mb-3" key={key}>
      <Form.Label>
        <b>{label}</b>
      </Form.Label>

      <Select
        options={selectOptions}
        isClearable
        placeholder={`Select ${label}`}
        value={
          selectOptions.find((option) => option.value === tempFilters[key]) ||
          null
        }
        onChange={(option) => updateFilter(key, option?.value || "")}
      />
    </Form.Group>
  );

  const handleApply = () => {
    onApplyFilters({ ...tempFilters });
    onHide();
  };

  const handleClear = () => {
    setTempFilters({ ...emptyFilters });
    onClearFilters();
    onHide();
  };

  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>Asset Details Filters</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Form>
          {renderSelect("User", "id_user", userOptions)}

          <Form.Group className="mb-3">
            <Form.Label>
              <b>Assign From Date</b>
            </Form.Label>
            <Form.Control
              type="date"
              value={tempFilters.assignFromDate}
              onChange={(e) => updateFilter("assignFromDate", e.target.value)}
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>
              <b>Assign To Date</b>
            </Form.Label>
            <Form.Control
              type="date"
              value={tempFilters.assignToDate}
              onChange={(e) => updateFilter("assignToDate", e.target.value)}
            />
          </Form.Group>

          {renderSelect("Vehicle", "vehicle", vehicleOptions)}

          <Form.Group className="mb-3">
            <Form.Label>
              <b>Approved</b>
            </Form.Label>
            <Form.Select
              value={tempFilters.approved}
              onChange={(e) => updateFilter("approved", e.target.value)}
            >
              <option value="">All</option>
              <option value="true">Yes</option>
              <option value="false">No</option>
            </Form.Select>
          </Form.Group>

          {renderSelect("Approved By", "approvedBy", approvedByOptions)}

          {renderSelect("Company", "company", companyOptions)}
        </Form>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={handleClear}>
          Remove Filters
        </Button>
        <Button variant="primary" onClick={handleApply}>
          Apply Filters
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
